

import axios from 'axios';

const URL = "https://api-inference.huggingface.co/models/impira/layoutlm-document-qa";

  export async function queryDocAPI(payload) {
    try {
        
      const response = await axios.post(URL, payload, {
        headers: {
          'Authorization': `Bearer ${process.env.REACT_APP_HUGGINGFACE_API_KEY}`,
          'Content-Type': 'application/json'
        }
      });

      console.log(response.data);
      return response?.data
    } catch (error) {
      console.error('Error Reading Doc:', error);
      return null;
    }
  }


